import { EnvironmentNames } from "@origin-digital/platform-enums";
import { FEATURE_FLAGS, getDefaultFeatures } from "./features";

export interface ChatClientAvailability {
  globallyEnabled?: boolean;
  routeEnabled?: boolean;
}

export const isChatClientSdkEnabled = ({
  globallyEnabled,
  routeEnabled,
}: ChatClientAvailability): boolean =>
  globallyEnabled === true && routeEnabled === true;

export const isChatClientSdkEnabledForEnvironment = (
  environment?: EnvironmentNames,
  routeEnabled?: boolean
): boolean =>
  isChatClientSdkEnabled({
    globallyEnabled:
      getDefaultFeatures(environment)[FEATURE_FLAGS.CHAT_CLIENT_SDK],
    routeEnabled,
  });
